import React, { KeyboardEventHandler } from 'react';
import * as Rally from '@rally/ui-themes/dist/web/rally/tokens.es6';
import cx from 'classnames';
import Select, { Props as ReactSelectProps } from 'react-select';
import { useDebounce } from 'rooks';
import styled from 'styled-components';
import { getRDSColor } from '@pass-frontend/utility/style-helpers';

export type SelectPropsGeneric<OptionType> = ReactSelectProps<OptionType>;

// export interface TypeaheadProps<
//   OptionType,
//   SelectProps extends SelectPropsGeneric<OptionType> = SelectPropsGeneric<OptionType>
// > {
//   onChange: SelectProps['onChange'];
//   value: SelectProps['value'];
//   passthruProps?: Partial<SelectProps>;
//   debouncingTime?: number;
// }

// NOTE: themes react-select to match RDS
const StyledTypeahead = styled.div`
  .typeahead__control {
    cursor: text;
    font-size: ${Rally.RDS_FONT_SIZE_14};
    box-shadow: none;
    color: ${Rally.RDS_COLOR_NEUTRAL_30};

    &.typeahead__control--is-focused {
      border-color: ${Rally.RDS_COLOR_NEUTRAL_30};
    }
    .typeahead__value-container {
      padding-top: 4px;
      padding-bottom: 4px;
    }
  }

  .typeahead__indicators {
    display: none;
  }

  .typeahead__option {
    font-size: ${Rally.RDS_FONT_SIZE_14};
    color: ${getRDSColor('primaryColor')};
    font-weight: ${Rally.RDS_FONT_WEIGHT_BOLD};
    cursor: pointer;

    &.typeahead__option--is-selected,
    &.typeahead__option--is-focused {
      background-color: ${Rally.RDS_COLOR_NEUTRAL_95};
    }
  }

  .typeahead__menu-list {
    padding-top: 0;
    padding-bottom: 0;
  }

  // hack around an weird menu showing issue.
  &.typeahead--no-options {
    .typeahead__menu {
      display: none;
    }
  }
  &.typeahead--error {
    .typeahead__control {
      border-color: ${getRDSColor('errorTextDangerColor')};
    }
  }
`;

/** NOTE: the `classNamePrefix` prop allows us to prefix a classname to all
 *    subcomponents AsyncSelect renders, and they just happen to name their
 *    classNames in BEM pattern, thus allowing us to re-theme it using the same pattern.
 */
export function Typeahead(props: any) {
  const {
    onChange,
    value,
    passthruProps: { onInputChange, ...restPassthru },
    debouncingTime,
  } = props;

  const debouncedInputChange = useDebounce(
    onInputChange,
    debouncingTime ?? 300,
  );

  const handleKeyDown: KeyboardEventHandler<HTMLDivElement> = (event) => {
    // console.log('777 handleKeyDown');
    switch (event.key) {
      case 'Enter':
        // TODO: Submit form

        // Hides isMenuOpen

        // When no options return
        if (!restPassthru?.options?.length) {
          // TODO: handle error in this scenario
          console.error('Error in Typeahead, no option is available');
        }
        break;
    }
  };

  return (
    <StyledTypeahead
      className={cx('typeahead rds-label', {
        'typeahead--no-options': !restPassthru?.options?.length,
        'typeahead--error': restPassthru?.shouldShowErrorMessage,
      })}
    >
      <Select
        classNamePrefix="typeahead rds-label"
        placeholder="Street Address, City & State, Zip Code"
        onInputChange={debouncedInputChange}
        // NOTE: this prop needs to be `null` or react-select will filter out options by input, so fuzzy matches will not display
        filterOption={null}
        defaultOptions={false}
        {...restPassthru}
        components={{
          LoadingIndicator: () => null,
        }}
        loadingMessage={() => null}
        onKeyDown={handleKeyDown}
        onChange={onChange}
        value={value}
        controlShouldRenderValue={true}
      />
    </StyledTypeahead>
  );
}

export default Typeahead;
